import { ResultType } from 'src/utils/datahub/enums'

export enum PinPostType {
  PIN = 'PIN',
  UNPIN = 'UNPIN'
}

export type UsePinPostProps = {
  postId: number
}

export type PinEventsProps = {
  type: `${PinPostType}`
  result: ResultType
  failureKind?: string
}

export type PathParams = {
  idCommunity: string
}
